import { render, staticRenderFns } from "./ModelCheckDialog.vue?vue&type=template&id=2bfbbb50&scoped=true"
import script from "./ModelCheckDialog.vue?vue&type=script&lang=js"
export * from "./ModelCheckDialog.vue?vue&type=script&lang=js"
import style0 from "./ModelCheckDialog.vue?vue&type=style&index=0&id=2bfbbb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfbbb50",
  null
  
)

export default component.exports